import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import OlxLogo from '../../assets/OlxLogo';

const MENS_CATEGORIES = ['Iron Sets', 'Drivers', 'Putters', 'Full Sets', 'Bags'];
const WOMENS_CATEGORIES = ['Iron Sets', 'Drivers', 'Full Sets', 'Ladies Bags'];
const JUNIOR_CATEGORIES = ["Boys' Sets", "Girls' Sets", 'By Age Group', 'Starter Kits'];

function Footer() {
  return (
    <div className="footerParentDiv">
      <div className="footerContent">
        <div className="footerContentInner">

          {/* 1. BRAND & SOCIAL SECTION */}
          <div className="footerColumn brandInfo">
            <OlxLogo />

            <div className="brandTaglineWrapper">
              <p className="brandTagline">
                India's dedicated marketplace for pre-owned golf equipment. Trusted by golfers across the country.
              </p>

              <div className="socialLinksInline">
                {/* Instagram */}
                <a
                  href="https://www.instagram.com/clubloopgolf?utm_source=qr"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Instagram"
                >
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                  </svg>
                </a>

                {/* Facebook */}
                <a
                  href="https://www.facebook.com/share/1DYXgQoBd1/?mibextid=wwXIfr"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Facebook"
                >
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M22.675 0h-21.35c-.732 0-1.325.593-1.325 1.325v21.351c0 .731.593 1.324 1.325 1.324h11.495v-9.294h-3.128v-3.622h3.128v-2.671c0-3.1 1.893-4.788 4.659-4.788 1.325 0 2.463.099 2.795.143v3.24l-1.918.001c-1.504 0-1.795.715-1.795 1.763v2.313h3.587l-.467 3.622h-3.12v9.293h6.116c.73 0 1.323-.593 1.323-1.325v-21.35c0-.732-.593-1.325-1.325-1.325z"/>
                  </svg>
                </a>

                {/* LinkedIn */}
                <a
                  href="https://www.linkedin.com/in/clubloop-golf-6351b73b7?utm_source=share_via&utm_content=profile&utm_medium=member_ios"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="LinkedIn"
                >
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
                  </svg>
                </a>
              </div>
            </div>
          </div>

          {/* 2. MEN'S CATEGORIES */}
          <div className="footerColumn">
            <h3 className="footerHeading">MEN'S</h3>
            <ul className="footerList">
              {MENS_CATEGORIES.map((item) => (
                <li key={item}>
                  <Link to={`/search?q=${encodeURIComponent('men ' + item)}`}>{item}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* 3. WOMEN'S CATEGORIES */}
          <div className="footerColumn">
            <h3 className="footerHeading">WOMEN'S</h3>
            <ul className="footerList">
              {WOMENS_CATEGORIES.map((item) => (
                <li key={item}>
                  <Link to={`/search?q=${encodeURIComponent('women ' + item)}`}>{item}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* 4. JUNIOR CATEGORIES */}
          <div className="footerColumn">
            <h3 className="footerHeading">JUNIOR</h3>
            <ul className="footerList">
              {JUNIOR_CATEGORIES.map((item) => (
                <li key={item}>
                  <Link to={`/search?q=${encodeURIComponent('junior ' + item)}`}>{item}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* 5. ABOUT US */}
          <div className="footerColumn">
            <h3 className="footerHeading">ABOUT US</h3>
            <ul className="footerList">
              <li><Link to="/about">About ClubLoop Group</Link></li>
              <li><Link to="/careers">Careers</Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
              <li><Link to="/about">Sustainability</Link></li>
            </ul>
          </div>

          {/* 6. SUPPORT / CLUB LOOP */}
          <div className="footerColumn">
            <h3 className="footerHeading">CLUB LOOP</h3>
            <ul className="footerList">
              <li><Link to="/help">Help</Link></li>
              <li><Link to="/sitemap">Sitemap</Link></li>
              <li><Link to="/legal">Legal & Privacy information</Link></li>
              <li><Link to="/help">Blog</Link></li>
            </ul>
          </div>

        </div>
      </div>

      {/* BOTTOM STRIP */}
      <div className="footerBottom">
        <div className="footerBottomInner">
          <p>© 2026 ClubLoop · Keep Golf Moving · India's Golf Equipment Marketplace</p>
        </div>
      </div>
    </div>
  );
}

export default Footer;
